export default __webpack_public_path__ + "static/media/CustomizeMessage.34baf1fb.svg";